export class Preloader {
	constructor(svgContent) {
		this.svgContent = svgContent;
		this.preloaderElement = null;
		this.isActive = false;
	}

	show() {
		if (this.isActive) return;

		this.preloaderElement = document.createElement('div');
		this.preloaderElement.className = 'preloader-layer';
		this.preloaderElement.innerHTML = this.svgContent;

		document.body.appendChild(this.preloaderElement);
		this.isActive = true;
	}

	hide() {
		if (!this.isActive || !this.preloaderElement) return;

		if (this.preloaderElement.parentNode) {
			this.preloaderElement.parentNode.removeChild(this.preloaderElement);
		}

		this.preloaderElement = null;
		this.isActive = false;
	}
	
	setSvg(svgContent) {
		this.svgContent = svgContent;

		// Если прелоадер активен, обновляем SVG
		if (this.isActive && this.preloaderElement) {
			this.preloaderElement.innerHTML = svgContent;
		}
	}
	
	isVisible() {
		return this.isActive;
	}
}
